import { ILibraryReference } from '../models/ILibraryReference.js';
export const libraryReference: ILibraryReference = {
	'base.actions': {
		key: 'base.actions',
	},
	'base.application': {
		key: 'base.application',
	},
	'base.button': {
		key: 'base.button',
	},
	'base.card': {
		key: 'base.card',
	},
	'base.carousel': {
		key: 'base.carousel',
	},
	'base.grid': {
		key: 'base.grid',
	},
	'base.icon': {
		key: 'base.icon',
	},
	'base.list': {
		key: 'base.list',
	},
	'base.text': {
		key: 'base.text',
	},
	'base.translate': {
		key: 'base.translate',
	},
	'management.fundManager': {
		key: 'management.fundManager',
	},
	'management.fundManagersCarousel': {
		key: 'management.fundManagersCarousel',
	},
	'overview.commentary': {
		key: 'overview.commentary',
	},
	'base.image': {
		key: 'base.image',
	},
	'base.checkbox': {
		key: 'base.checkbox',
	},
	'base.asset': {
		key: 'base.asset',
	},
	'base.link': {
		key: 'base.link',
	},
	'base.badge': {
		key: 'base.badge',
	},
	'base.contextMenu': {
		key: 'base.contextMenu',
	},
	'file.documentDownload': {
		key: 'file.documentDownload',
	},
	'file.documentDownloadList': {
		key: 'file.documentDownloadList',
	},
	'file.bulkDocumentDownload': {
		key: 'file.bulkDocumentDownload',
	},
	'base.tabs': {
		key: 'base.tabs',
	},
	'base.tab': {
		key: 'base.tab',
	},
	'charting.chartBase': {
		key: 'charting.chartBase',
	},
	'base.table': {
		key: 'base.table',
	},
	'overview.disclaimer': {
		key: 'overview.disclaimer',
	},
	'overview.disclaimers': {
		key: 'overview.disclaimers',
	},
	'overview.changeIndicator': {
		key: 'overview.changeIndicator',
	},
	'base.tooltip': {
		key: 'base.tooltip',
	},
	'risk.riskRating': {
		key: 'risk.riskRating',
	},
	'charting.barChart': {
		key: 'charting.barChart',
	},
	'charting.lineChart': {
		key: 'charting.lineChart',
	},
	'charting.areaChart': {
		key: 'charting.areaChart',
	},
	'charting.scatterChart': {
		key: 'charting.scatterChart',
	},
	'charting.chartTableCombo': {
		key: 'charting.chartTableCombo',
	},
	'base.asOfDate': {
		key: 'base.asOfDate',
	},
	'fact.fact': {
		key: 'fact.fact',
	},
	'fact.factList': {
		key: 'fact.factList',
	},
	'base.definitionList': {
		key: 'base.definitionList',
	},
	'fact.summaryBlock': {
		key: 'fact.summaryBlock',
	},
	'base.heading': {
		key: 'base.heading',
	},
	'base.search': {
		key: 'base.search',
	},
	'base.input': {
		key: 'base.input',
	},
	'base.pill': {
		key: 'base.pill',
	},
	'base.dropdown': {
		key: 'base.dropdown',
	},
	'fact.summaryBlocks': {
		key: 'fact.summaryBlocks',
	},
	'base.accordion': {
		key: 'base.accordion',
	},
	'base.accordionPanel': {
		key: 'base.accordionPanel',
	},
	'base.redirectButton': {
		key: 'base.redirectButton',
	},
	'base.dateSelection': {
		key: 'base.dateSelection',
	},
	'base.applicationEmbed': {
		key: 'base.applicationEmbed',
	},
	'overview.award': {
		key: 'overview.award',
	},
	'overview.awards': {
		key: 'overview.awards',
	},
	'charting.pieDoughnutChart': {
		key: 'charting.pieDoughnutChart',
	},
	'charting.chartLegend': {
		key: 'charting.chartLegend',
	},
	'base.color': {
		key: 'base.color',
	},
	'charting.chartPeriodSelection': {
		key: 'charting.chartPeriodSelection',
	},
	'base.morningStar': {
		key: 'base.morningStar',
	},
	'file.documentTile': {
		key: 'file.documentTile',
	},
	'file.documentTiles': {
		key: 'file.documentTiles',
	},
	'base.iconInput': {
		key: 'base.iconInput',
	},
	'base.buttonRaised': {
		key: 'base.buttonRaised',
	},
	'message.base': {
		key: 'message.base',
	},
	'message.errorMessage': {
		key: 'message.errorMessage',
	},
	'base.buttonFlat': {
		key: 'base.buttonFlat',
	},
	'message.infoMessage': {
		key: 'message.infoMessage',
	},
	'message.successMessage': {
		key: 'message.successMessage',
	},
	'base.imagePicker': {
		key: 'base.imagePicker',
	},
	'base.loadingIndicator': {
		key: 'base.loadingIndicator',
	},
	'base.labelledInput': {
		key: 'base.labelledInput',
	},
	'base.label': {
		key: 'base.label',
	},
	'base.noDataPlaceholder': {
		key: 'base.noDataPlaceholder',
	},
	'message.warningMessage': {
		key: 'message.warningMessage',
	},
	'base.confirmDialog': {
		key: 'base.confirmDialog',
	},
	'base.dialog': {
		key: 'base.dialog',
	},
	'base.paging': {
		key: 'base.paging',
	},
	'base.radioButtons': {
		key: 'base.radioButtons',
	},
	'portal.toast': {
		key: 'portal.toast',
	},
	'portal.toaster': {
		key: 'portal.toaster',
	},
	'portal.colorPicker': {
		key: 'portal.colorPicker',
	},
	'base.clickLayer': {
		key: 'base.clickLayer',
	},
	'base.calendarInput': {
		key: 'base.calendarInput',
	},
	'base.dateRangeInput': {
		key: 'base.dateRangeInput',
	},
	'base.numberPicker': {
		key: 'base.numberPicker',
	},
	'base.toggleButton': {
		key: 'base.toggleButton',
	},
	'base.sortButton': {
		key: 'base.sortButton',
	},
	'charting.rangeChart': {
		key: 'charting.rangeChart',
	},
	'base.savedSearch': {
		key: 'base.savedSearch',
	},
	'styledComponents.listButton': {
		key: 'styledComponents.listButton',
	},
	'base.savedSearchList': {
		key: 'base.savedSearchList',
	},
	'base.scale': {
		key: 'base.scale',
	},
	'charting.blockRangeChart': {
		key: 'charting.blockRangeChart',
	},
	'charting.relativePerformanceChart': {
		key: 'charting.relativePerformanceChart',
	},
	'charting.steppedBlockChart': {
		key: 'charting.steppedBlockChart',
	},
	'base.themeProvider': {
		key: 'base.themeProvider',
	},
	'charting.gaugeChart': {
		key: 'charting.gaugeChart',
	},
	'base.scaleLegend': {
		key: 'base.scaleLegend',
	},
	'base.weightingBar': {
		key: 'base.weightingBar',
	},
	'base.legend': {
		key: 'base.legend',
	},
	'charting.radialChart': {
		key: 'charting.radialChart',
	},
	'svg.svgCircle': {
		key: 'svg.svgCircle',
	},
	'svg.svgRect': {
		key: 'svg.svgRect',
	},
	'svg.svgPolygon': {
		key: 'svg.svgPolygon',
	},
	'base.virtualizedList': {
		key: 'base.virtualizedList',
	},
	'base.tableGrouping': {
		key: 'base.tableGrouping',
	},
	'svg.svg': {
		key: 'svg.svg',
	},
	'svg.rect': {
		key: 'svg.rect',
	},
	'charting.barScale': {
		key: 'charting.barScale',
	},
	'svg.line': {
		key: 'svg.line',
	},
	'svg.text': {
		key: 'svg.text',
	},
	'base.menu': {
		key: 'base.menu',
	},
	'base.menuList': {
		key: 'base.menuList',
	},
	'base.menuItem': {
		key: 'base.menuItem',
	},
	'base.divider': {
		key: 'base.divider',
	}
	/* [Component: assignment] */
	/* [ChartComponent: assignment] */
};
